import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { Box, Button, Flex, Heading, VStack } from '@chakra-ui/react'

import { Input } from '@/components/Form'

import { ErrorSection } from '@/components/Elements'
import useUser from '@/features/users/useUser'
import { setUser } from '@/stores/auth/authSlice'
import { useDispatch } from 'react-redux'
import { UserRole } from '../constants'

const UserNewPassword = () => {
  const [searchParams] = useSearchParams()

  const id = searchParams.get('id')
  const { useUpdateUser } = useUser()

  const updateUser = useUpdateUser()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const methods = useForm()
  const onSubmit = (data) => {
    if (!data.password) {
      toast.error('Missing Password')
      return
    }
    if (!data.confirmPassword) {
      toast.error('Please confirm the password again')
      return
    }

    if (data.password !== data.confirmPassword) {
      toast.error('Password is not the same ! ')
      methods.setError('confirmPassword', { type: 'custom', message: 'Password is not the same !' })
      return
    }

    updateUser.mutate(
      { id, data: { password: data.password } },
      {
        onSuccess: (res) => {
          dispatch(setUser(res))

          if (res?.role === UserRole.VENDOR) {
            navigate('/subcontractors/quotations')
          }
        },
        onError: ({ response: { data: errorResponseObj } }) => {
          if (errorResponseObj?.message) {
            toast.error(errorResponseObj?.message)
          }
        },
      }
    )
  }

  if (!id) {
    return <ErrorSection text="Missing User Id" />
  }
  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
          <Flex p={5} borderBottom="1px solid #d8dbe0">
            <Heading>New Password </Heading>
          </Flex>
          <Box p={5}>
            <VStack>
              <Input
                name="password"
                label="New Password"
                type="password"
                placeholder="Enter value"
                isRow
                isRequired
                autoComplete="false"
              />
              <Input
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                placeholder="Enter value"
                isRow
                isRequired
                autoComplete="false"
              />
            </VStack>
            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  )
}

export default UserNewPassword
